import { createTheme, Theme } from '@mui/material/styles';

const breakpointValues = {
    xs: 0,
    sm: 320,
    md: 840,
    lg: 1440,
    xl: 1680,
};

export const defaultTheme: Theme = createTheme({
    breakpoints: {
        values: breakpointValues,
    },
    palette: {
        mode: 'light', // Changed from 'type' to 'mode' (MUI v5 change)
        primary: {
            main: '#222c3c',
        },
        secondary: {
            main: '#006ED9',
            light: '#4092E3',
            dark: '#2684DF',
            contrastText: '#FFF',
        },
    },
    components: {
        // Changed from 'overrides' to 'components' (MUI v5 change)
        MuiCardContent: {
            styleOverrides: {
                root: {
                    paddingBottom: 8,
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: 16,
                },
            },
        },
    },
});
